<ng-container *ngIf="authorized">
    <ng-content></ng-content>
</ng-container>
<ng-container *ngIf="!authorized">
    <ng-content select="[notAuthorized]"></ng-content>
</ng-container>
